/**
 * @fileoverview Hook responsável por buscar, paginar e sincronizar tickets conforme os filtros informados.
 */

import { useState, useEffect } from "react";
import toastError from "../../errors/toastError";

import api from "../../services/api";

const useTickets = ({
  searchParam,
  tags,
  users,
  whatsappIds,
  pageNumber,
  status,
  date,
  updatedAt,
  showAll,
  queueIds,
  withUnreadMessages,
  withoutTags,
  isGroup,
  // Muda para reler a lista com os mesmos filtros (ex.: o admin trocou quem vê
  // as conversas). Não vai para a API.
  reloadKey,
}) => {
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(false);
  const [tickets, setTickets] = useState([]);

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchTickets = async () => {
        try {
          const params = {
            searchParam,
            pageNumber,
            tags,
            users,
            whatsappIds,
            status,
            date,
            updatedAt,
            showAll,
            queueIds,
            isGroup,
          };

          // Só adicionar withUnreadMessages se não for undefined
          if (withUnreadMessages !== undefined) {
            params.withUnreadMessages = withUnreadMessages;
          }

          if (withoutTags !== undefined) {
            params.withoutTags = withoutTags;
          }

          const { data } = await api.get("/tickets", { params });
          setTickets(data.tickets || []);
          setHasMore(data.hasMore);
          setLoading(false);
        } catch (err) {
          setLoading(false);
          toastError(err);
        }
      };
      fetchTickets();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [
    searchParam,
    tags,
    users,
    whatsappIds,
    pageNumber,
    status,
    date,
    updatedAt,
    showAll,
    queueIds,
    withUnreadMessages,
    withoutTags,
    isGroup,
    reloadKey,
  ]);

  return { tickets, loading, hasMore };
};

export default useTickets;
